Drupal.behaviors.schoolsMap = {
  attach: function (context, settings) {
    // Ensure we're iterating over elements within the context
    const historyNodes = context.querySelectorAll('[data-history-node-id]');

    historyNodes.forEach(function (node) {
      // Adding 'once' functionality
      if (node.classList.contains('history-node-processed')) {
        return; // Skip already processed nodes
      }
      node.classList.add('history-node-processed');

      // Mouseover event
      node.addEventListener('mouseover', function () {
        const nodeId = node.getAttribute('data-history-node-id');
        const targetElement = document.getElementById('schls-pin-' + nodeId);
        if (targetElement) {
          targetElement.style.backgroundColor = '#20c997';
          targetElement.style.width = '48px';
          targetElement.style.height = '48px';
          targetElement.style.fontSize = '1rem';
          targetElement.dataset.originalZIndex = targetElement.parentElement.style.zIndex;
          targetElement.parentElement.style.zIndex = 1000;
        }
      });

      // Mouseout event to revert changes
      node.addEventListener('mouseout', function () {
        const nodeId = node.getAttribute('data-history-node-id');
        const targetElement = document.getElementById('schls-pin-' + nodeId);
        if (targetElement) {
          targetElement.style.backgroundColor = '';
          targetElement.style.width = '';
          targetElement.style.height = '';
          targetElement.style.fontSize = '';
          targetElement.parentElement.style.zIndex = targetElement.dataset.originalZIndex || '';
          delete targetElement.dataset.originalZIndex; // Clean up
        }
      });
    });
  }
};
